NotificationHelper = LP.module('NotificationHelper')
RemoteHelper     = LP.module('RemoteHelper')

ProblemModalEvents =
  init : (triggeredFrom) ->
    $('.report-problem-trigger').click (e) ->
      if triggeredFrom == 'educator-rating'
        $('#report-problem-modal-root').remove();
        $('<div id="report-problem-modal-root"></div>').appendTo('body');
        $('#report-problem-modal-root').html('<div id="report-problem-modal" class="modal fade"></div>');
      modal = $('#report-problem-modal')
      modal.on('show.bs.modal', ->
        modal.load(e.currentTarget.getAttribute('data-url'), ->
          modalLoaded()
        )
      ).modal()
      modal.off('show.bs.modal')
      e.preventDefault()
      return

    # Reset form on each close
    $('#report-problem-modal').on 'hide.bs.modal', ->
      $form = $('#problem-form')
      $form.find('#problem-submit-btn').addClass('disabled').attr('disabled', true)
      $form.find('.checkbox').removeClass('has-error')
      $form.find('input').attr('checked', false)

    # Default close behavior is to close all modals on page
    $('#report-problem-modal').on 'click', '[data-dismiss="modal"]', (e) ->
      e.stopPropagation()
      $('#report-problem-modal').modal('hide')
      $('#js-copyright-info-popup').popover('hide')

    modalLoaded = ->
      $('#problem-form input[type="radio"]').on 'click', ->
        formLogic()
      $('#problem-form #task_notes').on 'keyup', ->
        formLogic()
      $('#problem-form').on 'ajax:complete', ->
        alertContainer = $('.panel-review:visible, .rp-header:visible').parent()
        $('.alert').remove()
        alertContainer.prepend(RemoteHelper.build_flash_alert_display(
            ['Thank you for your feedback.'], 'success'
        ))
        RemoteHelper.autoclose_alert(alertContainer)
        $('#report-problem-modal').on('hidden.bs.modal', ->
          $(this).find('form').trigger('reset')
        )
        $('#report-problem-modal').modal('hide')

      $('.html-info-popup').popover
        html: true
        sanitize: false
        placement: 'top'
        trigger: 'click'
        container: 'body'

      $('.info-popup').popover
        placement: 'top'
        trigger: 'click'
        container: 'body'

    formLogic = ->
      if $('#problem-form input[type="radio"]:checked').data('info-required') == true
        if $('#task_notes').val().length == 0
          disableSubmitButton()
          addAdditionalInfoError()
        else
          enableSubmitButton()
          removeAdditionalInfoError()
      else
        # there should always be an option that is checked
        if ($('#problem-form input[type="radio"]:checked').length > 0)
          enableSubmitButton()
          removeAdditionalInfoError()

    enableSubmitButton = ->
      $('#problem-form').find('#problem-submit-btn').removeClass('disabled').attr('disabled', false)

    disableSubmitButton = ->
      $('#problem-form').find('#problem-submit-btn').addClass('disabled').attr('disabled', true)

    addAdditionalInfoError = ->
      $('#problem-form #task_notes').parent().addClass('has-error')

    removeAdditionalInfoError = ->
      $('#problem-form #task_notes').parent().removeClass('has-error')

LP.module 'ProblemModalEvents', ProblemModalEvents
